<template>
  <div class="row col-12 q-px-xs">
    <div class="row col-12 q-my-lg">
      <span class="text-h6 text-brand-5 text-weight-bold texto-titulo">
        Observações
      </span>
    </div>
    <div
      v-if="pt.status != 'finalizado' && usuarioPodeEditar"
      class="row col-12"
    >
      <div class="col-11">
        <span class="text-brand-5 text-weight-bold q-ml-sm titulo-input"
          >Observação de Status: {{ formatarStatusDisplay(pt.status) }}</span
        >
        <q-input
          bg-color="white"
          v-model="observacao"
          :disable="!usuarioPodeEditar"
          type="textarea"
          class="input-text-area"
          outlined
          dense
        />
      </div>
      <div class="row col-11 justify-end q-mt-md">
        <div>
          <q-btn
            label="Enviar Observação"
            color="positive"
            no-caps
            class="btn"
            icon="check_circle_outline"
            @click="adicionarObservacao()"
          />
        </div>
      </div>
    </div>
    <div class="col-12 q-mt-xl">
      <span class="titulo-table q-ml-sm q-mb-lg text-brand-5 text-weight-bold">
        Histórico de Observações
      </span>
      <q-table
        :columns="columns"
        :rows="observacoesCombinadas"
        dense
        class="tabela-tamanho-fixo"
        :loading="loading"
        color="primary"
        flat
        table-header-class="bg-accent text-weight-bold"
        hide-bottom
        :rows-per-page-options="[0]"
        :pagination="{ rowsPerPage: 0 }"
      >
        <template v-slot:body-cell-status="props">
          <q-td style="padding: 0; margin: 0" key="ptStatus" :props="props">
            <div
              :style="{
                width: 'fit-content',
                padding: '2px 5px',
                background: getStatusBackground(props.row.ptStatus),
              }"
              class="row align items-center"
            >
              <span
                class="elipse q-mr-sm"
                :style="{ background: getStatusColor(props.row.ptStatus) }"
              ></span>
              <div
                :style="{ color: getStatusTextColor(props.row.ptStatus) }"
                class="text-bold"
              >
                {{ formatarStatusDisplay(props.row.ptStatus) }}
              </div>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-data="props">
          <q-td :props="props">
            <div>
              {{
                (props.row.dataHora || props.row.dataHoraLocal)
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
              <p style="margin: 0 0 0 4px">
                {{
                  (props.row.dataHora || props.row.dataHoraLocal).split(" ")[1]
                }}
              </p>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const columns = [
      {
        name: "nome",
        label: "Nome Responsável",
        field: "usuarioNome",
        align: "left",
      },
      {
        name: "observacao",
        label: "Observação",
        field: "observacao",
        align: "left",
      },
      {
        name: "status",
        label: "Status",
        align: "left",
      },
      {
        name: "data",
        label: "Data",
        align: "center",
      },
    ];

    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const pt = ref({});
    const loading = ref(false);
    const ptId = route.params.ptId;
    const observacao = ref("");

    const observacoesLocais = ref([]);
    const observacoesOriginais = ref([]);
    const contadorLocal = ref(1);

    const observacoesCombinadas = computed(() => {
      const observacoesBackendFiltradas =
        observacoesLocais.value.length === 0 ? observacoesOriginais.value : [];

      const todasObservacoes = [
        ...observacoesBackendFiltradas,
        ...observacoesLocais.value,
      ];

      return todasObservacoes.sort((a, b) => {
        const dataA = new Date(a.dataHora || a.dataHoraLocal);
        const dataB = new Date(b.dataHora || b.dataHoraLocal);
        return dataB - dataA;
      });
    });

    const gerarTimestampLocal = () => {
      const agora = new Date();
      const ano = agora.getFullYear();
      const mes = String(agora.getMonth() + 1).padStart(2, "0");
      const dia = String(agora.getDate()).padStart(2, "0");
      const hora = String(agora.getHours()).padStart(2, "0");
      const minuto = String(agora.getMinutes()).padStart(2, "0");
      const segundo = String(agora.getSeconds()).padStart(2, "0");

      return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
    };

    const gerarIdLocal = () => {
      return `local_${Date.now()}_${contadorLocal.value++}`;
    };

    const buscarDetalhePt = async (manterObservacoesLocais = false) => {
      loading.value = true;
      store.dispatch("pdt/hiddenHeader", true);

      try {
        const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
        pt.value = resposta.data.resultado.dados;

        if (!manterObservacoesLocais) {
          observacoesOriginais.value = pt.value.observacoes || [];
          carregarObservacoesLocais();
        } else {
          observacoesOriginais.value = pt.value.observacoes || [];
        }

        loading.value = false;
      } catch (error) {
        console.error("Erro ao buscar detalhes da PT:", error);
        loading.value = false;
      }
    };

    const salvarObservacoesLocais = () => {
      try {
        const chave = `pt_observacoes_locais_${ptId}`;
        localStorage.setItem(chave, JSON.stringify(observacoesLocais.value));
      } catch (error) {
        console.warn("Erro ao salvar observações locais:", error);
      }
    };

    const carregarObservacoesLocais = () => {
      try {
        const chave = `pt_observacoes_locais_${ptId}`;
        const observacoesSalvas = localStorage.getItem(chave);

        if (observacoesSalvas) {
          const observacoesParsed = JSON.parse(observacoesSalvas);

          observacoesLocais.value = observacoesParsed;
        } else {
          observacoesLocais.value = [];
        }
      } catch (error) {
        console.warn("Erro ao carregar observações locais:", error);
        observacoesLocais.value = [];
      }
    };

    const limparObservacoesSincronizadas = () => {
      observacoesLocais.value = observacoesLocais.value.filter(
        (obs) => !obs.sincronizada
      );
      salvarObservacoesLocais();
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) return false;
      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    const formatarStatusDisplay = (status) => {
      const statusMap = {
        aguardando_assinaturas: "Em Ass.",
        iniciado: "Iniciado",
        encerrado: "Encerrado",
        cancelado: "Cancelado",
        aberto: "Em Aberto",
        finalizado: "Finalizado",
      };
      return statusMap[status] || status;
    };

    const getStatusBackground = (status) => {
      const backgroundMap = {
        aguardando_assinaturas: "#fff6e3",
        iniciado: "#ecf1fe",
        encerrado: "#f8f8f8",
        cancelado: "#efecec",
        aberto: "#fefed1",
        finalizado: "#e8ffec",
      };
      return backgroundMap[status] || "#ffffff";
    };

    const getStatusColor = (status) => {
      const colorMap = {
        aguardando_assinaturas: "#dba700",
        iniciado: "#6391f4",
        encerrado: "#2d3e6e",
        cancelado: "#707070",
        aberto: "#b4a913",
        finalizado: "#00c853",
      };
      return colorMap[status] || "#000000";
    };

    const getStatusTextColor = (status) => {
      const textColorMap = {
        aguardando_assinaturas: "#683f09",
        iniciado: "#000000",
        encerrado: "#192957",
        cancelado: "#000000",
        aberto: "#b4a913",
        finalizado: "#000000",
      };
      return textColorMap[status] || "#000000";
    };

    const adicionarObservacao = async () => {
      if (!observacao.value || observacao.value.trim() === "") {
        quasar.notify({
          message: "Digite uma observação antes de enviar",
          color: "warning",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        return;
      }

      const novaObservacao = {
        id: gerarIdLocal(),
        observacao: observacao.value.trim(),
        ptStatus: pt.value.status,
        usuarioNome: store.getters["autenticacao/usuarioLogado"].nome,
        dataHora: gerarTimestampLocal(),
        dataHoraLocal: gerarTimestampLocal(),
        isLocal: true,
        sincronizada: false,
        tentativasSincronizacao: 0,
      };

      observacoesLocais.value.unshift(novaObservacao);
      salvarObservacoesLocais();

      observacao.value = "";

      quasar.notify({
        message: "Observação adicionada",
        color: "positive",
        actions: [{ label: "Fechar", color: "white", handler: () => {} }],
      });

      sincronizarObservacaoBackground(novaObservacao);
    };

    const sincronizarObservacaoBackground = async (observacao) => {
      try {
        await store.dispatch("pdt/adicionarObservacaoPorStatus", {
          ptId: ptId,
          observacao: observacao.observacao,
        });

        const obs = observacoesLocais.value.find((o) => o.id === observacao.id);
        if (obs) {
          obs.sincronizada = true;
          obs.isLocal = false;
          salvarObservacoesLocais();
        }
      } catch (error) {
        const obs = observacoesLocais.value.find((o) => o.id === observacao.id);
        if (obs) {
          obs.tentativasSincronizacao++;
          salvarObservacoesLocais();
        }
      }
    };

    const retentarSincronizacao = async () => {
      const observacoesPendentes = observacoesLocais.value.filter(
        (obs) => !obs.sincronizada && obs.tentativasSincronizacao < 3
      );

      for (const obs of observacoesPendentes) {
        try {
          await store.dispatch("pdt/adicionarObservacaoPorStatus", {
            ptId: ptId,
            observacao: obs.observacao,
          });

          obs.sincronizada = true;
          obs.tentativasSincronizacao++;
        } catch (error) {
          obs.tentativasSincronizacao++;
          console.warn(
            `Falha na sincronização da observação ${obs.id}:`,
            error
          );
        }
      }

      salvarObservacoesLocais();

      if (observacoesPendentes.some((obs) => obs.sincronizada)) {
        await buscarDetalhePt();
        limparObservacoesSincronizadas();
      }
    };

    const atualizarPtObservacoes = () => {
      if (pt.value) {
        pt.value.observacoes = observacoesCombinadas.value;
      }
    };

    computed(() => {
      atualizarPtObservacoes();
      return observacoesCombinadas.value;
    });

    onMounted(() => {
      buscarDetalhePt().then(() => {});

      setTimeout(retentarSincronizacao, 1000);
    });

    return {
      buscarDetalhePt,
      adicionarObservacao,
      observacao,
      columns,
      pt,
      usuarioPodeEditar,
      loading,
      observacoesCombinadas,
      formatarStatusDisplay,
      retentarSincronizacao,
      getStatusBackground,
      getStatusColor,
      getStatusTextColor,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.titulo-table {
  font-size: 17px;
}
@media (max-width: 600px) {
  .titulo-pagina {
    font-size: 14px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 9px !important;
  }
  .titulo-input {
    font-size: 12px;
  }
  .input-text-area {
    font-size: 12px;
  }
  .titulo-table {
    font-size: 13px;
  }
  .btn {
    font-size: 11px;
  }
}
</style>
